/**
 * Form values used by spot and mentions schedule listings.
 */
export type SchedulesListFilterValues = {
  from: string;
  to: string;
  customId: string;
  advertiser: string;
  campaign: string;
  version: string;
  order: string;
};

/**
 * Empty defaults for schedule metadata text filters.
 */
export const schedulesListMetadataDefaultValues = {
  advertiser: '',
  campaign: '',
  version: '',
  order: '',
} as const;

/**
 * Builds the API filter object for schedule listings from form values.
 */
export function buildSchedulesListFilter(
  values: SchedulesListFilterValues,
  type: 'SPOT' | 'MENTION',
): Record<string, unknown> {
  const filter: Record<string, unknown> = {
    type,
    'datetime.gte': values.from,
    'datetime.lte': values.to,
    customId: values.customId
      ?.split(',')
      .filter((v) => !!v)
      .map((v) => v.trim()),
  };

  const advertiser = values.advertiser?.trim();
  const campaign = values.campaign?.trim();
  const version = values.version?.trim();
  const order = values.order?.trim();

  if (advertiser) {
    filter.advertiser = advertiser;
  }

  if (campaign) {
    filter.campaign = campaign;
  }

  if (version) {
    filter.version = version;
  }

  if (order) {
    filter.order = order;
  }

  return filter;
}
